import { useState } from "react";
//Css
import styles from "./Login.module.scss";
//Components
import LoginOne from "./LoginOne";
import LoginTwo from "./LoginTwo";
import "./Login_global.scss";
export default function Login() {
  const [swapButton, setSwapButton] = useState("with-mobile");
  return (
    <>
      <div className={styles.container}>
        <div className={`changeTextColorToGreen ${styles.login_title}`}>
          ورود به حساب کاربری
        </div>
        <div className={styles.login_buttons}>
          <div
            className={`font_color_white ${styles.with_emai}`}
            onClick={() => setSwapButton("with-email")}
          >
            ورود با ایمیل
          </div>
          <div
            className={`font_color_white ${styles.with_mobile}`}
            onClick={() => setSwapButton("with-mobile")}
          >
            ورود با موبایل
          </div>
        </div>
        <div className={styles.lines_under_button}>
          <div
            className={`${styles.line_button} ${
              swapButton === "with-email"
                ? `changeTextColorToGreen ${styles.line_button_active}`
                : ""
            }`}
          ></div>
          <div className={styles.line_button}></div>
          <div
            className={`${styles.line_button} ${
              swapButton === "with-mobile"
                ? `changeTextColorToGreen ${styles.line_button_active}`
                : ""
            }`}
          ></div>
        </div>
        <main>
          {swapButton === "with-mobile" ? <LoginOne /> : <LoginTwo />}
        </main>
      </div>
    </>
  );
}
